exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.boxNt{\n\n  border-top: 3px solid #00897e;\n}\n.customNItem{\n\n  height: 60px!important;\n  border: 1px solid grey!important;\n  padding-top: 15px;\n  font-size: 20px;\n  background:white;\n}\n@media (min-width: 20px) and (max-width: 767px) {\n.seachMobButton {\n    padding: 0 !important;\n    height: 30px !important;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c1f74d14","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/cessioni/index.vue
// module id = 0w8F
// module chunks = 2